<template>
    <div>
        <b-row>
            <b-col md="6">
                <b-form-group label="Dil Kodu" label-for="languageCode" class="is-required">
                    <b-form-input id="languageCode" v-model="localValue.languageCode" placeholder="tr, en, de" maxlength="10" :state="getValidationState('languageCode')" />
                    <b-form-invalid-feedback :state="getValidationState('languageCode')">
                        {{ errors.languageCode }}
                    </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="Dil Adı" label-for="languageName" class="is-required">
                    <b-form-input id="languageName" v-model="localValue.languageName" placeholder="Türkçe, English, Deutsch" :state="getValidationState('languageName')" />
                    <b-form-invalid-feedback :state="getValidationState('languageName')">
                        {{ errors.languageName }}
                    </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="Sıra" label-for="sortOrder">
                    <b-form-spinbutton id="sortOrder" v-model="localValue.sortOrder" min="0" />
                </b-form-group>
            </b-col>

            <b-col md="6">
                <b-form-group label="Bayrak İkonu" label-for="flagIcon">
                    <b-form-input id="flagIcon" v-model="localValue.flagIcon" placeholder="🇹🇷 🇬🇧 🇩🇪" />
                    <small class="text-muted">Emoji veya icon kodu (örn: tr, gb)</small>
                </b-form-group>

                <b-form-group label="Ayarlar">
                    <b-form-checkbox v-model="localValue.isActive" switch class="mb-1">
                        {{ localValue.isActive ? "Aktif" : "Pasif" }}
                    </b-form-checkbox>

                    <b-form-checkbox v-model="localValue.isDefault" switch> Varsayılan Dil </b-form-checkbox>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { BRow, BCol, BFormGroup, BFormInput, BFormInvalidFeedback, BFormCheckbox, BFormSpinbutton } from "bootstrap-vue";

export default {
    name: "LanguageForm",
    components: {
        BRow,
        BCol,
        BFormGroup,
        BFormInput,
        BFormInvalidFeedback,
        BFormCheckbox,
        BFormSpinbutton,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
        errors: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            },
        },
    },
    methods: {
        getValidationState(field) {
            return this.errors[field] ? false : null;
        },
    },
};
</script>

<style scoped>
.is-required >>> label::after,
.is-required /deep/ label::after {
    content: " *";
    color: #dc3545;
    font-weight: 700;
}
</style>
